import useTracker from '@/hooks/useTracker';
import {
  CLICK_CANCEL_TRANSACTION,
  CLICK_CANCEL_TRANSACTION_YES,
  CLICK_CANCEL_TRANSACTION_NO,
} from '@services/trackerConst';

const useEventTracker = ({ orderDetail }) => {
  const { trackEvent } = useTracker();

  const orderDetailProps = {
    stock: orderDetail.code,
    order_side: orderDetail.order_side,
    account_type: orderDetail.account_type,
    order_type: orderDetail.order_type,
    period: orderDetail.order_period,
    price: orderDetail.price,
    lot: orderDetail.lot_count,
    total: orderDetail.total,
  };

  const eventShowPopupWithdraw = () => {
    trackEvent(CLICK_CANCEL_TRANSACTION, orderDetailProps);
  };

  const eventClickConfirmWithdraw = () => {
    trackEvent(CLICK_CANCEL_TRANSACTION_YES, orderDetailProps);
  };

  const eventClickCancelWithdraw = () => {
    trackEvent(CLICK_CANCEL_TRANSACTION_NO, orderDetailProps);
  };

  return {
    eventShowPopupWithdraw,
    eventClickConfirmWithdraw,
    eventClickCancelWithdraw,
  };
};

export default useEventTracker;
